// @flow

import React, { Component } from 'react';
import Overlay from './Overlay';
import Spinner from './Spinner';
import styled from 'styled-components';

const OverlayBackground = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  id: string,
  siblingId?: string, //id of a DOM element to which the overlay should be sibling -> which should overlay cover
};

export default class SpinnerOverlay extends Component<Props> {
  handlekeydown(e: any) {
    e.preventDefault();
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handlekeydown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handlekeydown, false);
  }

  render() {
    return (
      <Overlay id={this.props.id} siblingId={this.props.siblingId}>
        <OverlayBackground>
          <Spinner />
        </OverlayBackground>
      </Overlay>
    );
  }
}
